import moment from 'moment';

export const useFormatDate = (date) => {
  if (date) {
    const dateTotal = date.split('T')[0];
    return moment(dateTotal).format('DD/MM/yyyy');
  }
};
